<script lang="ts">
    import { Col, Label, Row } from "sveltestrap";
    import { Checkboxes, Option } from "../../../../utils/Constant/Constant";
</script>
<Row class="mb-0">
    <Col sm="3">
        <Label class="col-form-label pb-0">{Checkboxes}</Label>
    </Col>
    <Col sm="9">
        <div class="mb-0">
            <div class="form-check form-check-inline checkbox checkbox-primary">
                <input class="form-check-input" id="inline-form-1" type="checkbox">
                <label class="form-check-label" for="inline-form-1">{Option} 1</label>
            </div>
            <div class="form-check form-check-inline checkbox checkbox-primary">
                <input class="form-check-input" id="inline-form-2" type="checkbox">
                <label class="form-check-label" for="inline-form-2">{Option} 1</label>
            </div>
        </div>
    </Col>
</Row>